/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Disable_Confirm_ConfirmInputs */



/**
* | output |
* | --- |
* | "Show all chats" |
*
* @param {Project_Private_Chats_Disable_Confirm_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_disable_confirm_confirm = /** @type {((inputs?: Project_Private_Chats_Disable_Confirm_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Disable_Confirm_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Chats anzeigen")
	return /** @type {LocalizedString} */ ("Show all chats")
});